<template>
	<section>
		<header-page
			name="companies-new"
			:title="$route.meta.title"
		/>
		<plan-list
			v-if="showParentView('page-plan')"
			:codeProject="codeProject"
			:columns="columns"
			:rows="rows"
			:current-page="currentPage"
			@on-delete="loadPlans"
			@on-search="onSearch"
		/>
        <quick-actions
			v-if="$route.name === 'page-plan'"
            :actions="actions"
            @open-modal="openModal"
        >
        </quick-actions>
        <router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import planList from '@/components/plans/plan-list';

function openModal() {
	const codeProject = this.codeProject;
	this.goTo('page-new-plan', { params: { codeProject } });
}

function created() {
	if (this.$route.name === 'page-plan') {
		this.loadPlans();
	}
}

async function loadPlans() {
	const url = 'plan/list';
	try {
		const response = await this.$http.get(url);
		this.rows = [...response.data.data];
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CP',
				text: 'Crear Plan',
				icon: 'playlist_add',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
			{ id: 2, name: 'Descripción', checked: true, visible: true },
			{ id: 3, name: 'Precio', checked: true, visible: true },
			{ id: 4, name: 'Limite de Accesos', checked: true, visible: true },
			{ id: 5, name: 'Empresas', checked: true, visible: true },
			{ id: 6, name: 'Facturas Electrónicas', checked: true, visible: true },
			{ id: 7, name: 'Plan válido', checked: true, visible: true },
			{ id: 8, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		rows: [],
		currentPage: 1,
	};
}

export default {
	name: 'page-plan',
	components: {
		quickActions,
		planList,
	},
	created,
	data,
	methods: {
		openModal,
		loadPlans,
	},
	props: {
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-plan') {
					this.loadPlans();
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/plans/page-plan.vue